
































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { RED } from "@/resources/constants/busyReasons";
import moment from "moment-timezone";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { mixins } from "vue-class-component";
import Loader, { CANCELLATION_TIME } from "@/resources/mixins/loader/loader";
import { i18n } from "@/resources/locales";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { ROOM_TYPE } from "@/resources/constants/space";
import ConnectToRoomCall from "../../../../resources/mixins/chime/connectToRoomCall";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";

@Component({
  name: "webinar-enter-component",
})
export default class WebinarComponent extends mixins(
  Loader,
  ConnectToRoomCall,
  Plans
) {
  PLAN = PLAN;
  get active() {
    return this.$store.getters["WebinarStore/getShowEnterModal"];
  }
  get hasPin() {
    return this.$store.getters["WebinarStore/getHasPin"];
  }
  get roomId() {
    return this.$store.getters["WebinarStore/getRoomId"];
  }
  set active(e) {
    this.$store.dispatch("WebinarStore/setShowEnterModalAction", e);
  }
  onCancel() {
    this.active = false;
  }
  onEnter() {
    if (!this.activeOptionPlan(PLAN.WEBINAR))
      return;
    this.active = false;
    if (!this.hasPin) {
      const currentRoom = this.$store.getters["SystemStore/getCurrentRoom"];
      if (currentRoom)
        this.$store?.dispatch(
          "SystemStore/setOpenNotepadButtonAction",
          currentRoom.hasNotes
        );
      this.connectToRoomCall(this.$store, this.roomId);
    } else {
      this.$store?.dispatch("MeetingStore/setRoomIdAction", this.roomId);
      this.$store?.dispatch("SystemStore/setShowPinRoomModalAction", true);
      this.$store?.dispatch("SystemStore/setIsChangePinAction", false);
    }
  }
}
